import type { FEATURE_FLAGS } from '@pkgs/shared/constants';
import useAuthSettings from './useAuthSettings';

const useFeatureFlag = (name: ArrayElement<typeof FEATURE_FLAGS>) => {
	const authSettings = useAuthSettings(['featureFlags']);

	return Boolean(authSettings?.featureFlags.includes(name));
};

export default useFeatureFlag;
